module.exports = __webpack_public_path__ + "static/img/3.22c846d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/zh/3.png
// module id = ftK7
// module chunks = 0